module.exports = __webpack_public_path__ + "static/media/icon_sachwerte.ed7288af.svg";